<template>
    <div class="ion-page">
        <ion-header>
          <ion-toolbar class="mobile-header-toolbar">
            <ion-buttons v-slot: start>
              <ion-menu-button></ion-menu-button>
              <ion-title>User Management</ion-title>
              <ion-button @click="addUser" class="download-file">
                <ion-icon v-slot: start :icon="add"></ion-icon>&nbsp;
                Add New User
            </ion-button>
            </ion-buttons>
          </ion-toolbar>
        </ion-header>
        <ion-content>
            <ion-grid>
                <ion-row class="rectangle">
                    <ion-col>
                        <ion-row align-items-stretch>
                            <ion-col size="12" size-md="2">
                                <ion-label class="section-head">User Name</ion-label>
                                <div class="border-line-34 margin-top-10">
                                    <ion-input
                                    class="form-input"
                                    type="text"
                                    id="name"
                                    @input="name = $event.target.value"
                                    maxlength="50"
                                    ></ion-input>
                                </div>
                            </ion-col>
                            <ion-col size="12" size-md="2">
                                <ion-label class="section-head">Address</ion-label>
                                <div class="border-line-34 margin-top-10">
                                    <ion-input
                                    class="form-input"
                                    type="text"
                                    id="city"
                                    @input="city = $event.target.value"
                                    maxlength="100"
                                    ></ion-input>
                                </div>
                            </ion-col>
                            <ion-col size="12" size-md="2">
                                <br />
                                <ion-button class="btn-search margin-top-10" @click="searchUser">Search</ion-button>
                                <ion-button class="btn-clear margin-top-10" @click="clearFields">
                                    <ion-icon :icon="refresh"></ion-icon>
                                </ion-button>
                            </ion-col>
                        </ion-row>
                    </ion-col>
                </ion-row>
            </ion-grid>
            <div v-if="this.usersList != null">
                <ion-grid>
                    <ion-row class="list-head">
                        <ion-col>
                            <ion-label>User Name</ion-label>
                        </ion-col>
                        <!-- <ion-col>
                            <ion-label>Email</ion-label>
                        </ion-col> -->
                        <ion-col>
                            <ion-label>City</ion-label>
                        </ion-col>
                        <ion-col>
                            <ion-label>State</ion-label>
                        </ion-col>
                        <ion-col>
                            <ion-label>Mobile No</ion-label>
                        </ion-col>
                        <ion-col>
                            <ion-label>Status</ion-label>
                        </ion-col>
                    </ion-row>
                    <ion-row  class="station-list" v-for="user in usersList" :key="user">
                        <ion-col>
                            <ion-label class="ext-link station-name" @click="viewUser(user)">{{ user.firstName }}</ion-label>
                        </ion-col>
                        <!-- <ion-col>
                            <ion-label>{{ user.email }}</ion-label>
                        </ion-col> -->
                        <ion-col>
                            <ion-label>{{ user.address.city }}</ion-label>
                        </ion-col>
                        <ion-col>
                            <ion-label>{{ user.address.state.name }}</ion-label>
                        </ion-col>
                        <ion-col>
                            <ion-label>{{ user.mobile }}</ion-label>
                        </ion-col>
                        <ion-col>
                            <ion-label v-bind:class="(user.status.code == 'A') ? 'user-active-status' :  'user-inactive-status'">{{ user.status.name }}</ion-label>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </div>
        </ion-content>
        
    </div>
</template>

<script>
import { defineComponent, render } from "vue";
import { refresh, add } from 'ionicons/icons';
import Chart from "chart.js/auto";
import { CorporateService } from "../../service/corporate/corporate.service";
import { flash } from 'ionicons/icons';
import { IonButton, IonRow, IonCol, IonGrid, IonIcon, IonInput, IonLabel, IonSelect, IonSelectOption, IonSpinner } from "@ionic/vue";
import { ToastUtils } from "../../util/toast-utils";
import userData from "../../../public/assets/data/data.json";

export default defineComponent ({
    name: 'energyConsumedDashboard',
    components: {
        IonGrid, IonRow, IonCol, IonLabel, IonSelect, IonSelectOption, IonInput, IonButton, IonIcon, IonSpinner
    },
    data() {
        return {
            refresh,
            add,
            loaderTab: true,
            users: userData.usersList,
            name : '',
            city : '',
            norecordsfound: false,
            totalRecords: 0,
            pageRecords: 15,
            pageNo: 1,
            pagesList: [],
            totalPages: 0,
            usersList: [],
            displayBackBtn: false
        }
    },
    async mounted() {
        let usersList = JSON.parse(localStorage.getItem('usersList'));
        if(usersList != null) {
           this.usersList = usersList
        } else {
            this.usersList = this.users;
            localStorage.setItem("usersList" , JSON.stringify(this.usersList));
            
        }
    },
    
    methods: {
        navigatePreviousPage() {
            this.$router.go(-1)
        },
        changeDateFormat(dateValue) {
            return moment(dateValue).format('YYYY-MM-DD HH:mm:ss')
        },
        changeDateFormatWithoutTime(dateValue) {
            if(dateValue != null) {
                return moment(dateValue).format('DD/MMM/YYYY')
            }
        },
        convertUppercase(value) {
            return value.toUpperCase()
        },
        async addUser() {
            localStorage.removeItem('userDetails');
            localStorage.setItem('profileMode', "New")
            this.$router.push('carterProfileEdit')
        },
        clearFields() {
            this.name = null;
            this.city = null;
            document.getElementById("name").value = null;
            document.getElementById("city").value = null;
            this.effectiveFrom = null;
            this.effectiveTo = null;
            this.status = null;
            localStorage.removeItem('stationSearch');
            localStorage.removeItem('stationPage');
            this.usersList = [];
            this.usersList = this.stations;
            this.norecordsfound = false;
        },
        async searchUser() {
            this.usersList = [];
            let listOfUser= []
            if((this.name == null || this.name == '') && (this.city == null || this.city == '')) {
                // this.usersList = this.stations
                let usersList = JSON.parse(localStorage.getItem('usersList'));
                    if(usersList != null) {
                    this.usersList = usersList
                } else {
                    this.usersList = this.users;
                    localStorage.setItem("usersList" , JSON.stringify(this.usersList));
                }
            } else {
                this.users.forEach((user) => {
                    if((this.name != '' && this.name != null) && (this.city != null && this.city != '')) {
                        if((((user.firstName).toLocaleLowerCase()).match((this.name).toLocaleLowerCase())) && (((user.address.city).toLocaleLowerCase()).match((this.city).toLocaleLowerCase()))) {
                            listOfUser.push(user)
                        }
                    }

                    if((this.name != '' || this.name != null) && (this.city == null || this.city == '')) {
                        if(((user.firstName).toLocaleLowerCase()).match((this.name).toLocaleLowerCase())) {
                            listOfUser.push(user)
                        }
                    }
                    if((this.name == '' || this.name == null) && (this.city != null || this.city != '')) {
                        if(((user.address.city).toLocaleLowerCase()).match((this.city).toLocaleLowerCase())) {
                            listOfUser.push(user)
                        }
                    }
                })
                if(listOfUser.length > 0) {
                    this.usersList = listOfUser;
                } else {
                    this.norecordsfound = true;
                }
            }
        },
        viewUser(user) {
            localStorage.setItem('profileMode', "Update")
            localStorage.setItem("userDetails", JSON.stringify(user))
            this.$router.push('carterProfileEdit')
        }
    }
})
</script>

<style scoped>
    
.download-file {
    font-size: 12px;
    background: #cc412c;
    color: white;
    text-decoration: none;
    /* padding: 3px; */
    border-radius: 5px;
    margin-right: 30px;
}

.list-head ion-label{
    padding:5px;
    color: #041648;
    font-size: 14px;
    font-weight: bold;
}
.station-list {
    padding: 5px;
    font-size: 13px;
    border-bottom: 1px solid grey;
    background: #dadcdf;
}
.user-active-status {
    color: #3bab40;
    font-size: 13px;
    font-weight: bold;
    padding: 5px;
    background: white;
    opacity: 0.8;
    border-radius: 5px;
}
.user-inactive-status {
    color: #e45a41;
    font-size: 13px;
    font-weight: bold;
    padding: 5px;
    background: white;
    opacity: 0.8;
    border-radius: 5px;
}
.station-name{
    font-weight: bold;
    /* color: #c8412b; */
    color: #0e3457;
}
.ext-link {
  cursor: pointer;
}
.section-head {
    text-align: left;
    font-family: "Roboto Medium";
    font-size: 15px;
    letter-spacing: 0;
    color: #041648;
    opacity: 1;
}
</style>
